/**
 * Papeis que acessam os dashboards: os do tier contratante, mais os de
 * plataforma. Os assentos de empresa (adm-user, company-user) ficam de fora,
 * junto de free e support.
 *
 * Espelha DashboardRequest::PAPEIS_COM_DASHBOARD no backend-api. A lista vive
 * nos dois repositorios porque o payload de login devolve apenas o nome do
 * papel; alterada de um lado, precisa ser alterada do outro.
 */
export const PAPEIS_COM_DASHBOARD: ReadonlyArray<string> = [
  'super-admin',
  'admin',
  'dpo',
  'manager-adm',
  'manager',
  'company',
  'startup',
  'liberal',
]

export function podeVerDashboard(papel?: string | null): boolean {
  return !!papel && PAPEIS_COM_DASHBOARD.includes(papel)
}
